import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { InvoiceTemplateFormData, InvoiceTemplateRelatedAttributes } from "@/formTypes/InvoiceTemplateDataType";
import { InvoiceTemplateFormDataKeys } from "@/generated/InvoiceTemplateFormDataKeys";
import { InvoiceTemplateProductApi, InvoiceTemplateProductDataType } from "./InvoiceTemplateProductApi";
import { omitProperties } from "@utils/Utils";

export type InvoiceTemplateDataType = Partial<ApiSchema["InvoiceTemplate"]["type"] & InvoiceTemplateFormData>;

class Api extends GenericModelApi<"InvoiceTemplate", InvoiceTemplateDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<InvoiceTemplateDataType>> {
        const selectionSet = [
            ...InvoiceTemplateFormDataKeys.filter(k => !InvoiceTemplateRelatedAttributes.includes(k)),
            "currency.*",
            "invoiceTemplateProducts.*",
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async createInvoiceTemplateAndProducts(input: InvoiceTemplateDataType, products: InvoiceTemplateProductDataType[]): Promise<InvoiceTemplateDataType> {
        const { data, errors } = await ApiClient.models["InvoiceTemplate"].create(input);
        if (!errors && data && data?.id) {
            const resultInvoiceTemplateProduct = await Promise.all(
                products.map((p) => {
                    const product = { ...p };
                    delete product.id
                    delete product.forceRecalculatePrice
                    product.invoiceTemplateId = data.id
                    return InvoiceTemplateProductApi.create(product);
                })
            )
        } else if (errors) {
            throw new ApiError(`Errores al crear ${String(this.modelName)}`, "API_ERROR", errors);
        }
        this.invalidateAllByTenant()
        this.clearCache()

        return data || {} as InvoiceTemplateDataType;
    }

    async updateInvoiceTemplateAndProducts(input: InvoiceTemplateDataType, products: InvoiceTemplateProductDataType[]): Promise<InvoiceTemplateDataType> {
        const { data, errors } = await this.model.update(input);
        if (!errors && data && data?.id) {
            const resultInvoiceTemplateProduct = await Promise.all(
                products.map((p) => {
                    let product = {
                        ...p,
                    };
                    if (product.preSavedId) {
                        product.id = product.preSavedId;
                        delete product.preSavedId;
                    } else {
                        delete product.id;
                    }
                    product = omitProperties(product, ["forceRecalculatePrice", "selected", "descriptionFact", "priceFact", "subtotalFact", "descuentoFact", "impuestosFact", "impuestos_servicioFact"])
                    product.invoiceTemplateId = data.id
                    if (product.id) {
                        return InvoiceTemplateProductApi.update(product.id, product);
                    } else {
                        return InvoiceTemplateProductApi.create(product);
                    }
                })
            )
        } else if (errors) {
            throw new ApiError(`Errores al crear ${String(this.modelName)}`, "API_ERROR", errors);
        }
        this.invalidateAllByTenant()
        this.clearCache()

        return data || {} as InvoiceTemplateDataType;
    }


}
export const InvoiceTemplateApi = new Api("InvoiceTemplate", "numero")